{
  "info": "Інформація",
  "negative": "Помилка",
  "positive": "Успішно"
}
